import React from 'react';
import Node, {
  NodeProps,
} from 'components/canvas/components/nodes/components/base-node';
import NodeHeader from 'components/canvas/components/nodes/components/base-node/components/node-header';
import NodeContextMenu from 'components/canvas/components/nodes/components/base-node/components/node-context-menu';
import NodeSnapshot from 'components/canvas/components/nodes/components/node-snapshot';
import GlobalLinksIndicator from 'components/canvas/components/nodes/components/base-node/components/global-links-indicator';
import useNodeDimensionsOperations from 'components/canvas/hooks/use-node-dimensions-operations';
import { Text } from 'react-konva';
import DownloadIcon from './components/download-icon';
import DeleteIcon from 'components/canvas/components/nodes/components/base-node/components/node-context-menu/components/delete-icon';

interface DocumentNodeProps extends NodeProps {}

function DocumentNode(props: DocumentNodeProps) {
  const { node } = props;

  const { getNodeDimensionsByType } = useNodeDimensionsOperations();

  const { width, height } = getNodeDimensionsByType(node?.type);

  const nodeWithSnippetLinks = {
    ...node,
  };
  console.log(' DOC NODE ', node, props);

  const isSupported = node.format != 'FILE' || node.mimeType == 'video/mp4';

  const isVideo = node.format == 'FILE' && node.mimeType == 'video/mp4';
  // if(!isSupported){
  const styleLink = isVideo
    ? { fill: '#757575' }
    : isSupported
    ? { fill: '#fff8' }
    : { fill: '#d8415a' };
  //   delete props.showNodeModal
  // }

  function iconsRenderer({ icons }): React.ReactElement[] | null {
    const ownerIcons = [
      // /*  <SurfaceNodeEditIcon onClick={showSurfaceEditForm} />,
      ...(Object.values(icons) as React.ReactElement[]),
      // <DownloadIcon node={node}></DownloadIcon>,
    ];

    // if (!x.isFixed) {
    //   ownerIcons.push(<IncreaseIcon node={node}></IncreaseIcon>);

    //   ownerIcons.push(<DecreaseIcon node={node}></DecreaseIcon>);

    //   ownerIcons.push(
    //     <DeleteIcon
    //       node={node}
    //       // onAfterDelete={props.onAfterDelete}
    //       hardDelete={false}
    //     />,
    //   );
    //   ownerIcons.reverse();
    // }
    if (isSupported) {
      return ownerIcons;
    } else {
      return [
        <DownloadIcon node={node}></DownloadIcon>,
        <DeleteIcon
          node={node}
          // onAfterDelete={props.onAfterDelete}
          hardDelete={false}
        />,
      ];
    }
  }

  return (
    <Node
      {...props}
      style={styleLink}
      width={width}
      height={isSupported && !isVideo ? height : height / 2.5}
      showNodeModal={(event) => {
        if (isSupported && props.showNodeModal) {
          return props.showNodeModal(event);
        }
        console.log(' ON CLICK');
      }}
      cursor={isSupported ? 'pointer' : 'not-allowed;'}>
      {({ Rect }) => {
        if (isSupported) {
          console.log('RECT: ', Rect);
          if (isVideo) {
            return (
              <>
                {React.cloneElement(Rect, { cornerRadius: 5 })}
                <NodeHeader
                  x={0}
                  offsetY={40}
                  fill="#1C1B18"
                  fontStyle="bold"
                  text={node.risk + ' : ' + node.name ?? ''}
                  width={width - 30}
                  isReference={Boolean(node.isReference)}
                />

                <GlobalLinksIndicator node={nodeWithSnippetLinks} x={width} />
                <Text
                  x={20}
                  y={10}
                  text={`Video`}
                  // fontFamily={typography.font.fontFamily}
                  width={width - 10 * 2.3}
                  // height={height - horizontalMargin}
                  fontSize={16}
                  lineHeight={1.5}
                  wrap="char"
                />

                {/* <NodeSnapshot node={node} width={width} height={height} /> */}

                {/* NodeContextMenu has to be last component in tree because of z index and how react-konva assigns it to elements */}
                <NodeContextMenu
                  width={width}
                  height={height}
                  node={node}
                  icons={iconsRenderer}
                />
              </>
            );
          } else {
            return (
              <>
                {node.risk && React.cloneElement(Rect, { cornerRadius: 5 })}
                <NodeHeader
                  x={0}
                  offsetY={40}
                  fill="#1C1B18"
                  fontStyle="bold"
                  text={node.name ?? ''}
                  width={width - 30}
                  isReference={Boolean(node.isReference)}
                />

                <GlobalLinksIndicator node={nodeWithSnippetLinks} x={width} />

                <NodeSnapshot node={node} width={width} height={height} />

                {/* NodeContextMenu has to be last component in tree because of z index and how react-konva assigns it to elements */}
                <NodeContextMenu
                  width={width}
                  height={height}
                  node={node}
                  icons={iconsRenderer}
                />
              </>
            );
          }
        } else {
          return (
            <>
              {React.cloneElement(Rect, { cornerRadius: 5 })}
              <NodeHeader
                x={0}
                offsetY={45}
                fill="#1C1B18"
                fontStyle="bold"
                text={node.name ?? ''}
                width={width - 30}
                isReference={Boolean(node.isReference)}
              />

              <Text
                x={20}
                y={10}
                text={`Document Type \n"${node.mimeType}"\n is not supported yet`}
                // fontFamily={typography.font.fontFamily}
                width={width - 10 * 2.3}
                // height={height - horizontalMargin}
                fontSize={16}
                lineHeight={1.5}
                wrap="char"
              />
              <NodeContextMenu
                width={width}
                height={height}
                node={node}
                icons={iconsRenderer}
              />
            </>
          );
        }
      }}
    </Node>
  );
}

export default DocumentNode;
